import {IReportData, emptyReportData} from "../../entities/reports/IReportData";
import {FetchState} from "../../entities/FetchState";
import { Reducer } from "redux";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import Either from "../../utils/Either";
import {callApiWithResult, ICallResult, IError} from "../../utils/callApi";


/**********************************************************
 * API Data
 **********************************************************/
export interface IData {
    id: string
    naam: string
    adress: string | null
    city: string | null
    region: string | null
    active: boolean
    telefoon: string | null
}
export const defaultContactpointListByCity: IReportData<IData> = emptyReportData()

/**********************************************************
 * State
 **********************************************************/

export interface IState {
    ContactpointListByCity: IReportData<IData>
    currentCityStreamId: string | null
}
export const InitialState: IState = {
    ContactpointListByCity: defaultContactpointListByCity,
    currentCityStreamId: null
}

/**********************************************************
 * Action Types
 **********************************************************/
export enum ActionTypes {
    FetchData = "contactpoint.ContactpointListByCity Fetch",
    FetchDataSuccess = "contactpoint.ContactpointListByCity FetchSuccess",
    FetchDataFailed = "contactpoint.ContactpointListByCity FetchFailed"
}

/**********************************************************
 * Actions & Creators
 **********************************************************/
export interface IFetchData {
    type: ActionTypes.FetchData,
    payload: { cityStreamId: string }
}
export interface IFetchDataSuccess {
    type: ActionTypes.FetchDataSuccess,
    payload: { data: IData[], cityStreamId: string }
}
export interface IFetchDataFailed {
    type: ActionTypes.FetchDataFailed,
    payload: { errorMessage: string }
}
type Actions = IFetchData | IFetchDataSuccess | IFetchDataFailed;

export class ActionCreators {
    public static FetchData(cityStreamId: string): IFetchData {
        return { 
            type: ActionTypes.FetchData,
            payload: { cityStreamId }
        };
    }
    public static FetchDataSuccess(newData: IData[], cityStreamId: string): IFetchDataSuccess {
        return {
            type: ActionTypes.FetchDataSuccess,
            payload: { data: newData, cityStreamId }
        };
    }
    public static FetchDataFailed(err: string): IFetchDataFailed {
        return {
            type: ActionTypes.FetchDataFailed,
            payload: { errorMessage: err }
        };
    }
}

/**********************************************************
 * Reducer
 **********************************************************/
export const Reducers: Reducer<IState, Actions> = (state = InitialState, action) => {
    switch (action.type) {
        case ActionTypes.FetchData:
            return { 
                ...state,
                currentCityStreamId: action.payload.cityStreamId,
                ContactpointListByCity: {
                    ...state.ContactpointListByCity,
                    state: FetchState.Busy
                }
            };
        case ActionTypes.FetchDataSuccess:
            return { 
                ...state,
                currentCityStreamId: action.payload.cityStreamId,
                ContactpointListByCity: {
                    ...state.ContactpointListByCity,
                    state: FetchState.Success,
                    data: action.payload.data,
                    fetchDate: new Date()
                }
            };
        case ActionTypes.FetchDataFailed:
            return { 
                ...state,
                ContactpointListByCity: {
                    ...state.ContactpointListByCity,
                    state: FetchState.Error,
                    errorMessage: action.payload.errorMessage
                }
            };
        default:
            return state;
    }
}

/**********************************************************
 * Sagas
 **********************************************************/

function* handleIFetchData(action: IFetchData) {
    try {
        const response : Either<IError, ICallResult<IData[]>> = yield call(callApiWithResult, 'GET', `/v1/contactpoint/city/${action.payload.cityStreamId}`);
        yield response
            .FlatMap(success => put(ActionCreators.FetchDataSuccess(success.result, action.payload.cityStreamId) as any))
            .Reduce(error => put(ActionCreators.FetchDataFailed(error.text) as any))
    } catch (err) {
        yield put(ActionCreators.FetchDataFailed(JSON.stringify(err)))
    }
}

function* watchAll() {
    yield takeEvery(ActionTypes.FetchData, handleIFetchData)
}
export function* sagas() {
    yield all([fork(watchAll)]);
}

